import BaseRepository from "~/api/BaseRepository";
import type { $Fetch } from "nitropack";

export const PersonaRepository = (client: $Fetch) => ({
    ...BaseRepository(client)('v2/personas'),
});